import React, { lazy, Suspense } from "react";
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import { CookiesProvider } from "react-cookie";
import { StateProvider } from './Store/Store';

import { Loading } from "@vfid/lib-id-fe-shared";

const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);


// Solution for reCAPTCHA lnown issue: Uncaught (in promise) Timeout (B)

if (process.env.NODE_ENV === "development") {
	window.onunhandledrejection = (event) => {
		// event.preventDefault();
		
		if(event.reason === "Timeout (B)"){
			const errorFrame = document.querySelector('iframe[id*="webpack"]');
			if (errorFrame) {
				errorFrame.remove();
			}
		}
	}
};

root.render(
	<Suspense fallback={<Loading />}>
		<CookiesProvider>
			<StateProvider>
					<App/>
			</StateProvider>
		</CookiesProvider>
	</Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
